export default "__VITE_ASSET__CR2Pe0I6__"